import { Modal, ModalClose, ModalDialog } from '@mui/joy';

import { useState } from 'react';

import { Button, Tooltip } from '@/design-system';
import { useChangePaymentPlanMutation } from '@/hooks/useSwr';
import { ChangePaymentPlanTierSchema, PaymentPlanTier } from '@/types/schema';

export function RenewSubscriptionModal(props: {
  changeToTier: ChangePaymentPlanTierSchema;
  disabled: boolean;
  planType: PaymentPlanTier;
  price: number;
  maxSeats: number;
  onSubscribeSuccess?: () => void;
}) {
  const [isRenewSubscriptionModalOpen, setIsRenewSubscriptionModalOpen] =
    useState(false);
  const {
    trigger: changePlanTrigger,
    isMutating: changePlanIsMutating,
    error,
  } = useChangePaymentPlanMutation({
    onSuccess: props.onSubscribeSuccess,
  });
  const capitalizedPlan =
    props.planType.charAt(0).toUpperCase() + props.planType.slice(1);
  const confirmButton = (
    <div className="self-end">
      <Button
        size="md"
        color="primary"
        disabled={changePlanIsMutating || props.disabled}
        loading={changePlanIsMutating}
        onClick={async () => {
          await changePlanTrigger({
            json: {
              tier: props.changeToTier,
            },
          });
          if (!error) setIsRenewSubscriptionModalOpen(false);
        }}
      >
        Renew Subscription
      </Button>
    </div>
  );

  const subscribeButton = (
    <div className="flex w-full self-start">
      <Button
        size="sm"
        color="primary"
        disabled={props.disabled}
        onClick={() => {
          setIsRenewSubscriptionModalOpen(true);
        }}
        className="w-full"
      >
        Renew Subscription
      </Button>
    </div>
  );
  return (
    <>
      <Modal
        open={isRenewSubscriptionModalOpen}
        onClose={(_, reason) => {
          if (reason === 'backdropClick') return;
          setIsRenewSubscriptionModalOpen(false);
        }}
      >
        <ModalDialog variant="outlined" sx={{ minWidth: 550 }}>
          <div className="flex flex-col items-stretch gap-8">
            <div className="inline-flex flex-col items-start justify-start gap-5 px-5 pt-3">
              <div className="self-stretch text-lg font-semibold leading-7">
                Renewing Subscription to the {capitalizedPlan} plan
              </div>
              <div className="inline-flex flex-col items-start justify-start gap-3">
                <div className="w-[427px] text-base font-normal leading-tight text-tertiary">
                  Thanks for choosing to renew your subscription.
                </div>
                <div className="w-[427px] text-base font-normal leading-tight text-tertiary">
                  You’re re-joining our {capitalizedPlan} plan for $
                  {props.price} a month for each seat billed monthly.
                </div>
              </div>
            </div>
            {confirmButton}
            {error && <div className="text-error">{error.message}</div>}
          </div>
          <ModalClose />
        </ModalDialog>
      </Modal>
      {props.disabled ? (
        <Tooltip title="Add a payment method below to renew">
          <div>{subscribeButton}</div>
        </Tooltip>
      ) : (
        subscribeButton
      )}
    </>
  );
}
